// src/pages/Sitemap.js
import React, { useEffect } from 'react';
import { getArticles } from '../firebase';

const Sitemap = () => {
  useEffect(() => {
    const generateSitemap = async () => {
      try {
        const articles = await getArticles();
        const today = new Date().toISOString().split('T')[0];
        
        let sitemap = `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9"
        xmlns:news="http://www.google.com/schemas/sitemap-news/0.9">
  
  <!-- ===== STATIC PAGES ===== -->
  
  <!-- Homepage -->
  <url>
    <loc>https://kohlanewspakistan.asia/</loc>
    <lastmod>${today}</lastmod>
    <changefreq>daily</changefreq>
    <priority>1.0</priority>
  </url>

  <!-- About Page -->
  <url>
    <loc>https://kohlanewspakistan.asia/about</loc>
    <lastmod>${today}</lastmod>
    <changefreq>monthly</changefreq>
    <priority>0.5</priority>
  </url>

  <!-- News Page (All Articles) -->
  <url>
    <loc>https://kohlanewspakistan.asia/news</loc>
    <lastmod>${today}</lastmod>
    <changefreq>daily</changefreq>
    <priority>0.9</priority>
  </url>

  <!-- Features Page -->
  <url>
    <loc>https://kohlanewspakistan.asia/features</loc>
    <lastmod>${today}</lastmod>
    <changefreq>weekly</changefreq>
    <priority>0.7</priority>
  </url>

  <!-- Breaking News Page -->
  <url>
    <loc>https://kohlanewspakistan.asia/breaking</loc>
    <lastmod>${today}</lastmod>
    <changefreq>daily</changefreq>
    <priority>0.9</priority>
  </url>

  <!-- Latest News Page -->
  <url>
    <loc>https://kohlanewspakistan.asia/latest</loc>
    <lastmod>${today}</lastmod>
    <changefreq>daily</changefreq>
    <priority>0.9</priority>
  </url>

  <!-- Subscribe Page -->
  <url>
    <loc>https://kohlanewspakistan.asia/subscribe</loc>
    <lastmod>${today}</lastmod>
    <changefreq>monthly</changefreq>
    <priority>0.4</priority>
  </url>

  <!-- Contact Page -->
  <url>
    <loc>https://kohlanewspakistan.asia/contact</loc>
    <lastmod>${today}</lastmod>
    <changefreq>monthly</changefreq>
    <priority>0.5</priority>
  </url>`;

        // Add dynamic articles from Firebase
        if (articles && articles.length > 0) {
          sitemap += `
  
  <!-- ===== DYNAMIC ARTICLES (from Firebase) ===== -->`;
          
          articles.forEach(article => {
            sitemap += `
  <url>
    <loc>https://kohlanewspakistan.asia/news/${article.slug}</loc>
    <lastmod>${article.date || today}</lastmod>
    <changefreq>weekly</changefreq>
    <priority>0.8</priority>
    <news:news>
      <news:publication>
        <news:name>Kohla News</news:name>
        <news:language>en</news:language>
      </news:publication>
      <news:publication_date>${article.date || today}</news:publication_date>
      <news:title>${article.title}</news:title>
      <news:keywords>${article.tags ? article.tags.join(', ') : ''}</news:keywords>
    </news:news>
  </url>`;
          });
        }

        sitemap += `
</urlset>`;

        // Display sitemap
        document.body.innerHTML = `<pre style="font-family: monospace; white-space: pre-wrap; padding: 20px;">${sitemap}</pre>`;
        
      } catch (error) {
        console.error('Error generating sitemap:', error);
        document.body.innerHTML = 'Error generating sitemap';
      }
    };

    generateSitemap();
  }, []);

  return null;
};

export default Sitemap;